import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminDemoControl = lazy(() => import("@/pages/admin/AdminDemoControl"));

export const Route = createFileRoute("/admin/demo-control")({
  component: AdminDemoControl,
});
